var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showPage),expression:"showPage"}],staticClass:"container"},[_c('div',{staticClass:"logo"}),_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language"},[_c('a',{attrs:{"href":"cn/"}},[_vm._v("简体中文")]),_c('a',{attrs:{"href":"tw/"}},[_vm._v("繁體中文")])])
}]

export { render, staticRenderFns }